document.addEventListener("DOMContentLoaded", function(){
    var secs = document.querySelectorAll('section');
    var currentSection = 0;
    const button = document.querySelector('.page-banner__button');
	if(button) {
        button.addEventListener('click', function() {
            window.scroll({
                top: secs[++currentSection].offsetTop - 100,
                left: 0,
                behavior: 'smooth'
            });
        });
	};
});